import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TGetUser = {
    userId?: string;
    projectId?: string;
};

export default async ({ userId, projectId }: TGetUser = {}) => {
    const tempHeaders = {
        auth: true,
        "x-user-id": userId,
        "x-project-id": projectId,
    };

    if (!userId) delete tempHeaders["x-user-id"];
    if (!projectId) delete tempHeaders["x-project-id"];

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/hourControl/read`,
        method: "get",
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    const errorFeedBacks = {
        401: "Acesso negado!",
        404: "Controle de horas não encontrado",
    };

    return handleStatusCases({ body, statusCode, errorFeedBacks });
};
